import { render } from "./BreadCrumb.vue?vue&type=template&id=ce5c1cba&scoped=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&lang=js"

import "./BreadCrumb.vue?vue&type=style&index=0&id=ce5c1cba&scoped=true&lang=css"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=ce5c1cba&scoped=true&lang=sass"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce5c1cba"]])

export default __exports__